// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const oranguru: PokeData = {
  "id": 765,
  "name": "oranguru",
  "height": 15,
  "weight": 760,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "confusion",
    "psychic",
    "feint-attack",
    "psych-up",
    "future-sight",
    "taunt",
    "calm-mind",
    "nasty-plot",
    "zen-headbutt",
    "trick-room",
    "foul-play",
    "after-you",
    "stored-power",
    "quash",
    "instruct"
  ],
  "moves": [
    "psychic",
    "future-sight",
    "calm-mind",
    "zen-headbutt",
    "quash",
    "body-slam",
    "leer",
    "scratch",
    "headbutt",
    "prismatic-cage",
    "synchronize",
    "splash",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 394,
    "item": null,
    "species": [
      {
        "name": "oranguru",
        "order": 765,
        "types": [
          PokeType.NORMAL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 99,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
